<template>

  <!-- Program Element -->
  <page-block
    class="program-element"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    v-if="hasContent && items.length"
    wrapper-class="program-element__wrapper">

    <!-- Title -->
    <h1
      v-if="hasTitle"
      class="sbs-mb text-bold">
      {{ value.title.ru }}
    </h1>

    <q-tabs
      v-model="tab"
      align="justify"
      v-if="tabs.length">

      <!-- Tab -->
      <q-tab
        :key="index"
        :name="tab.name"
        :label="tab.label"
        class="sections-tabs__tab"
        v-for="(tab, index) in tabs"/>

    </q-tabs>

    <div
      class="ibs-mt"
      :key="event.id"
      v-for="event in events"
      v-show="tab === event.id">

      <event-theme-card
        :value="theme"
        :key="theme.id"
        :hall="event.hall"
        v-for="theme in event.themes"/>

    </div>

  </page-block>

</template>

<script>

  import {mapState} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import EventThemeCard from '@src/components/card/event-theme-card';

  export default {
    name: 'program-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      EventThemeCard,
    },
    data() {
      return {
        tab: null,
      };
    },
    computed: {
      ...mapState('vlEvents', {
        items: 'items',
      }),
      events() {

        return this.items.filter(
          v => v.startDate
            && v.themes.length,
        );
      },
      tabs() {

        return this.events.map(event => ({
          name: event.id,
          label: this.$date.humanDate({
            first: event.startDate,
            local: true,
          }),
        }));
      },
    },
    mounted() {

      this.tab = this.events.length
        ? this.events[0].id
        : null;
    },
  };

</script>

<style lang="scss">

  .program-element {
    color: inherit;

    .event-theme-card {
      margin-top: 4px;
    }

    .q-tab {
      min-height: 60px;
    }

    .q-tab__label {
      font-size: 1.5rem;
    }

    .q-tab__indicator {
      height: 4px;
    }
  }

</style>
